import { useEffect } from 'react';
import type { Editor } from '@tiptap/react';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { isZoneCell, OpenHeaderFooter, openHeaderFooterKey } from 'containers/Tiptap/lib/header-footer-zone';

export const getLeftZoneCaret = (doc: ProseMirrorNode): number | null => {
  let caret: number | null = null;
  doc.descendants((node, pos) => {
    if (caret !== null) return false;
    if (!isZoneCell(node)) return true;
    const paragraph = node.firstChild;
    if (paragraph?.isTextblock) caret = pos + 2 + paragraph.content.size;
    return false;
  });
  return caret;
};

const placeCaretInLeftZone = (editor: Editor): void => {
  if (editor.isDestroyed) return;
  const caret = getLeftZoneCaret(editor.state.doc);
  if (caret === null) editor.commands.focus('start');
  else editor.chain().focus().setTextSelection(caret).run();
};

export const useHeaderFooterCaret = (open: OpenHeaderFooter | null): void => {
  const zoneEditor = open?.editor ?? null;
  const openKey = openHeaderFooterKey(open);

  useEffect(() => {
    if (!zoneEditor || !openKey) return undefined;
    const timer = window.setTimeout(() => placeCaretInLeftZone(zoneEditor), 0);
    return () => window.clearTimeout(timer);
  }, [zoneEditor, openKey]);
};
